module.exports = __webpack_public_path__ + "09_long_yellow.0a67b2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/09_long_yellow.png
// module id = TQOg
// module chunks = 0